import React from "react";
import { IoMdOpen } from "react-icons/io";

function Tooltip() {
  return (
    <div className="tooltip">
      Click to search on wookieepedia
      <IoMdOpen />
    </div>
  );
}

export default Tooltip;
